<template>
  <div v-loading="formLoading">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams">
        <!-- 地区部 -->
        <el-form-item label="地区部">
          <el-select
            filterable
            v-model="queryParams.areaName"
            placeholder="请选择区域"
            clearable
            @change="changeArea"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.areaName"
              :value="item.areaName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select
            filterable
            v-model="queryParams.countryName"
            placeholder="请选择国家"
            clearable
          >
            <el-option
              v-for="(item, index) in countryList.filter(item => {
                return item.areaName == queryParams.areaName;
              })"
              :key="index"
              :label="item.countryName"
              :value="item.countryName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车型 -->
        <el-form-item label="车型">
          <el-select
            filterable
            v-model="queryParams.carModel"
            placeholder="请选择"
            clearable
            multiple
          >
            <el-option
              v-for="(item, index) in carModelList"
              :key="index"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年份 -->
        <el-form-item label="年份">
          <el-date-picker
            type="year"
            value-format="yyyy"
            v-model="queryParams.years"
            placeholder="请选择"
            :clearable="false"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 月份 -->
        <el-form-item label="月份">
          <el-select filterable clearable v-model="queryParams.months">
            <el-option
              v-for="item in 12"
              :key="item"
              :label="item + '月'"
              :value="item < 10 ? '0' + item : item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作 -->
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="doSearch"
            >查询</el-button
          >
          <el-button type="primary" size="small" @click="handleResetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-tabs class="tabs_container" v-model="pageIndex">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <div v-if="showTab">
      <div class="title">
        {{ showDataObj.queryParams.countryName }} 市场
        {{ showDataObj.queryParams.months }} 月分析月报
      </div>
      <div class="time">
        更新日期：{{ showDataObj[this.pageIndex + "Time"] }}
      </div>
      <!-- 看差距 -->
      <look-gap-tab
        ref="lookGapTab"
        v-show="pageIndex === 'lookGapTab'"
        @updateTime="updateTime"
      />
      <!-- 看市场 -->
      <look-market-tab
        ref="lookMarketTab"
        v-show="pageIndex === 'lookMarketTab'"
        @updateTime="updateTime"
      />
      <!-- 看行业 -->
      <look-industry-tab
        ref="lookIndustryTab"
        v-show="pageIndex === 'lookIndustryTab'"
        @updateTime="updateTime"
      />
      <!-- 看竞争 -->
      <look-compete-tab
        ref="lookCompeteTab"
        v-show="pageIndex === 'lookCompeteTab'"
        @updateTime="updateTime"
      />
      <!-- 看客户 -->
      <look-customer-tab
        ref="lookCustomerTab"
        v-show="pageIndex === 'lookCustomerTab'"
        @updateTime="updateTime"
      />
    </div>
  </div>
</template>

<script>
import LookGapTab from "./components/lookGapTab/index.vue";
import LookMarketTab from "./components/lookMarketTab/index.vue";
import LookIndustryTab from "./components/lookIndustryTab/index.vue";
import LookCompeteTab from "./components/lookCompeteTab/index.vue";
import LookCustomerTab from "./components/lookCustomerTab/index.vue";
import * as moment from "moment";
import {
  getAreaCountryListApi,
  getInfoDetailApi
} from "@/api/saleTaskCollection";
import { getDictItem } from "@/util/dict";

export default {
  components: {
    LookGapTab,
    LookMarketTab,
    LookIndustryTab,
    LookCompeteTab,
    LookCustomerTab
  },
  data() {
    return {
      // 区域
      areaList: [],
      // 国家
      countryList: [],
      // 车型
      carModelList: [],
      // 搜索条件
      queryParams: {
        areaName: "", // 区域
        countryName: "", // 国家
        carModel: "", // 车型
        years: moment().format("YYYY"), // 年份
        months: moment().format("MM") // 月份
      },
      pickerOptions: {
        disabledDate(time) {
          const preYear = 2021;
          const afterYear = new Date().getFullYear();
          return time.getFullYear() > afterYear || time.getFullYear() < preYear;
        }
      },
      formLoading: false,
      tabList: [
        { label: "看差距", name: "lookGapTab" },
        { label: "看市场", name: "lookMarketTab" },
        { label: "看行业", name: "lookIndustryTab" },
        { label: "看竞争", name: "lookCompeteTab" },
        { label: "看客户", name: "lookCustomerTab" }
      ],
      pageIndex: "lookGapTab", // 当前显示tab索引
      showTab: false, // 是否显示tab (选中地区部国家查询出数据后显示)
      showDataObj: {
        queryParams: {},
        lookGapTabTime: "", // 看差距更新时间
        lookMarketTabTime: "", // 看市场更新时间
        lookIndustryTabTime: "", // 看行业更新时间
        lookCompeteTabTime: "", // 看竞争更新时间
        lookCustomerTabTime: "" // 看客户更新时间
      }
    };
  },
  created() {
    // 获取区域国家
    this.getAreaCountryList();
    // 获取车型
    this.getCarTypeList();
  },
  methods: {
    // 获取地区国家列表
    async getAreaCountryList() {
      const res = await getAreaCountryListApi();
      this.areaList = res.data.saleAreaList || [];
      this.countryList = res.data.saleCountryList || [];
    },
    // 获取车型列表
    async getCarTypeList() {
      this.carModelList = await getDictItem("carType");
    },
    // 区域改变
    changeArea() {
      this.queryParams.countryName = "";
    },
    // 搜索
    async doSearch() {
      this.formLoading = true;
      try {
        const res = await getInfoDetailApi({
          areaName: this.queryParams.areaName,
          countryName: this.queryParams.countryName
        });
        if (res.status == 0) {
          this.showDataObj.queryParams = {
            ...JSON.parse(JSON.stringify(this.queryParams)),
            carModel: this.queryParams.carModel.join(",")
          };
          this.showTab = true;
          this.$nextTick(async () => {
            let promiseArr = [
              this.$refs.lookGapTab.init(this.showDataObj),
              this.$refs.lookMarketTab.init(this.showDataObj),
              this.$refs.lookIndustryTab.init(this.showDataObj),
              this.$refs.lookCompeteTab.init(this.showDataObj),
              this.$refs.lookCustomerTab.init(this.showDataObj)
            ];
            await Promise.all(promiseArr);
            this.formLoading = false;
          });
        } else {
          this.showTab = false;
          this.$DonMessage.error(res.message);
          this.formLoading = false;
        }
      } catch (error) {
        this.showTab = false;
        this.formLoading = false;
      }
    },
    // 重置
    handleResetQuery() {
      this.queryParams = Object.assign({}, this.$options.data()?.queryParams);
      this.showTab = false;
    },
    // 时间更新
    updateTime(field, time) {
      if (field) {
        this.showDataObj[field] = time ? moment(time).format("YYYY-MM-DD") : "";
      } else {
        this.showDataObj[this.pageIndex + "Time"] = moment().format(
          "YYYY-MM-DD"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-container {
  padding: 30px 20px 0 20px;
  border-bottom: 5px solid #efefef;
  ::v-deep .el-input {
    width: 150px;
  }
}
.tabs_container {
  padding-top: 15px;
  ::v-deep {
    .el-tabs__item {
      font-size: 16px;
      height: 34px;
      line-height: 32px;
    }
    .el-tabs__nav-wrap {
      padding: 0 40px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
  }
}
.title {
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}
.time {
  display: flex;
  justify-content: right;
  font-size: 14px;
  padding: 0 20px;
}
</style>
